/* ============================================================
 * N2T ship-week — fulfillment warehouse configuration
 *
 * Net to Table uses CC3PL as its 3PL fulfillment partner.
 * This file encodes CC3PL's operational rules: the daily order
 * cutoff hour, the warehouse timezone, holiday closures, etc.
 * Update the values here as CC3PL policy changes.
 *
 * NOTE: Premier Packing (Bellingham WA) is the seafood processor
 * — RFM-certified facility that receives, packs, and freezes the
 * catch. They do NOT do fulfillment. Don't confuse the two.
 *
 * ──── How the math works (current rule, set by ops) ─────────
 *
 * Customer boxes always ARRIVE on the target arrival day
 * (currently Thursday). The math is arrival-first, not ship-first.
 * Algorithm:
 *
 *   effective_order_date =
 *     today                  if customer-local time < 10am PT
 *     today + 1 day          otherwise
 *
 *   IF effective_order_date + transit_days ≤ this week's Thursday:
 *     → ship this week, arrival = this Thursday
 *   ELSE:
 *     → ship next week, arrival = next Thursday
 *
 * Ship date is computed as (arrival_date - transit_days). Because
 * transit varies by zone (Pacific 1d, East 4d), the ship day VARIES
 * but arrival is always Thursday — the customer always sees a
 * Thursday arrival in the pill.
 *
 * Loaded BEFORE ship-week.js (see ship-week-display.liquid).
 * Consumed via window.N2T_SHIP_WAREHOUSE.
 *
 * TODO (ops): get the following from CC3PL ops contact:
 *   - Actual warehouse zip (origin_zip)
 *   - Actual warehouse city (origin_label)
 *   - Confirmed weekly closure / 2026 holiday calendar (blackout_dates)
 *   - Whether weekend ship (Sat/Sun) is allowed
 *   - Any pack lead-time requirement (pack_lead_hours)
 * ============================================================ */
(function () {
  'use strict';

  window.N2T_SHIP_WAREHOUSE = {
    /* ---------- Origin (CC3PL warehouse) ---------- */
    origin_zip: '60090',                  // CC3PL — Wheeling, IL (Chicago area)
    origin_label: 'Wheeling, IL',
    origin_timezone: 'America/Chicago',   // Central Time

    /* ---------- Daily cutoff hour ----------
     * Hour (24h, in warehouse timezone) before which orders are
     * processed for SAME-day shipping. After this hour, orders
     * roll over to the next-day batch.
     *
     * Set by ops: 10am Central (warehouse local time).
     */
    daily_cutoff_hour: 10,

    /* ---------- Air-upgrade policy ----------
     * Wild seafood is perishable — ground shipments longer than
     * `air_upgrade_threshold_days` are upgraded to 2nd Day Air to
     * keep cold-chain integrity.
     *
     * Set by ops: anything > 3 ground days ships 2nd Day Air (2 days).
     *
     * Applied at zone lookup time — `window.N2T_SHIP_ZONES.lookup(zip)`
     * returns `transit_days` already adjusted by this policy.
     * `ground_transit_days` is preserved for reference.
     */
    air_upgrade_threshold_days: 3,
    air_transit_days: 2,

    /* ---------- Blackout dates ----------
     * Days the warehouse does NOT ship (holidays, planned closures,
     * weather events). Format: ISO date strings "YYYY-MM-DD" in the
     * warehouse timezone.
     *
     * If the target arrival Thursday is in this list, the math pushes
     * arrival forward by one week.
     *
     * Update annually with CC3PL's confirmed holiday calendar.
     */
    blackout_dates: [
      // '2026-11-27',  // Thanksgiving Day
      // '2026-12-25',  // Christmas Day
      // '2027-01-01',  // New Year's Day
      // '2026-07-04',  // Independence Day
      // '2026-09-01',  // Labor Day
      // Add CC3PL-confirmed closures here.
    ],

    /* ---------- Pack lead time (reserved for future) ----------
     * Hours required between order placement and ship-out.
     * Currently NOT used — placeholder for v3 logic if CC3PL
     * adds a queue / batching delay before any package ships.
     */
    pack_lead_hours: 0,
  };
})();
